import React, { useState, FC } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useScmSaleSoDetailModel } from "../scmSaleSoModel";
import { ISCMSaleSoGoodsDetail } from "../scmSaleSoType";
import { RouterParamType } from "@/model/navModel";
import { useScmSaleRoDetailModel } from "../../scmSaleRo/scmSaleRoModel"
import { formatNum } from "@/utils/utils";

export const TableBox: FC<RouterParamType> = ({ id, mode, type }) => {
    const { getTreeNodeName } = useScmSaleRoDetailModel();
    const { lookSoGoodsList, lookSoFormVal } = useScmSaleSoDetailModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const newFormVal = lookSoFormVal

    // 供应链销售单详情列表
    const soColumns: ColumnsType<ISCMSaleSoGoodsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any, record: ISCMSaleSoGoodsDetail) => <span
            //     style={{ cursor: "pointer", color: "#00f" }}
            //     onClick={() => setGoodsRecordModal({ visible: true, materialCode: record.materialCode, materialName: record.materialName, code: newFormVal.customerCode })}>
            //     {text}</span>,
            // sorter: {
            //     compare: (a: { materialCode: string; }, b: { materialCode: string; }) => a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0),
            //     multiple: 1,
            // },
        }, {
            title: '商品名称',
            width: 250,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: string, record: any) => <p className="ellipsis" title={text}>{record.giftId && <span style={{ background: "orange", color: "white" }}>赠</span>}{text}</p>
        }, {
            title: '库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'num',
            // sorter: {
            //     compare: (a: { num: number | string; }, b: { num: number | string; }) => +a.num - +b.num,
            //     multiple: 2,
            // },
        },
        // 优惠类型为赠品时，显示quantitySold字段
        // newFormVal.preferentialTypeCode === DictCodeEnmu.PREFERENTIAL_TYPE_GIFT?{
        newFormVal.preferentialTypeCode === 'PREFERENTIAL_TYPE_GIFT' ? {
            title: '已销数量',
            width: 100,
            dataIndex: 'quantitySold',
        } : {

        },
        {
            title: '单价',
            width: 136,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '下浮',
            width: 100,
            dataIndex: 'discountRate',
        },
        {
            title: '应赠数量',
            width: 100,
            dataIndex: 'giftsPayable',
        },
        {
            title: '赠品数量',
            width: 100,
            dataIndex: 'giftsNum',
        },
        {
            title: '剩余数量',
            width: 100,
            dataIndex: 'giftsSurplus',
        },
        {
            title: '单品合计 优惠',
            width: 136,
            dataIndex: 'favorableAmount',
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '总计',
            width: 136,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '商品类型',
            width: 140,
            dataIndex: 'typeName',
        }, {
            title: '货位',
            width: 130,
            dataIndex: 'shelfCode',
        }, {
            title: '本次出库',
            width: 100,
            dataIndex: 'confirmNum',
        },
        {
            title: '已出库数量',
            width: 100,
            dataIndex: 'stockIoNum',
        }, {
            title: '驳回数量',
            width: 100,
            dataIndex: 'rejectNum',
            render: (text: string) => <span className={+text > 0 ? "color-red" : ""}>{text}</span>
        }, {
            title: '出库状态',
            width: 130,
            dataIndex: 'stockIoStatus',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
        },
        // {
        //     title: '三包',
        //     width: 80,
        //     dataIndex: 'isProtect',
        //     editable: EditableOrNot(editFormVal.status),
        //     editType: "select",
        //     options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
        //     render: (text: number) => text == 1 ? "是" : "否"
        // }, 
        {
            title: '替换编号',
            width: 160,
            dataIndex: 'replaceCode',
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitName',
        }, {
            title: '积压标记',
            width: 80,
            dataIndex: 'overstock',
        }, {
            title: '积压等级',
            width: 80,
            dataIndex: 'overstockGrade',
        },
        {
            title: '销售单号',
            width: 100,
            dataIndex: 'saleCode',
        },
        {
            title: '采购单号',
            width: 200,
            dataIndex: 'purchaseCode',
        },
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
        {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
        }
    ];
    return (
        <YhBox title="" style={{ marginBottom: "20px" }}>
            <Table
                rowKey={record => record.key}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMSaleSoGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={soColumns}
                dataSource={lookSoGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}